module.exports = "<div class=\"title-section\">\n\n</div>\n<div class=\"chart-section\">\n\n</div>";